let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kg4LX")).then(() => parcelRequire('lvHUa'));